import React from "react";
import {
  FaCalendarAlt,
  FaCheckCircle,
  FaClock,
  FaHashtag,
  FaUser,
} from "react-icons/fa";

const formatDisplayDate = (value) => {
  if (!value) return "—";
  try {
    return new Date(value).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return value;
  }
};

const formatUpdatedAt = (value) => {
  if (!value) return "—";
  try {
    return new Date(value).toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  } catch {
    return value;
  }
};

const statusLabel = (status) => {
  if (status === "ACTIVE") return "ACTIVE";
  if (status === "DRAFT") return "DRAFT";
  if (status === "INACTIVE") return "INACTIVE";
  return status || "—";
};

export default function CmsPageVersionOverview({ version }) {
  if (!version) {
    return (
      <div className="cms-page-overview">
        <h3 className="cms-page-overview__title">Version Overview</h3>
        <p className="cms-page-overview__empty">No version selected.</p>
      </div>
    );
  }

  const rows = [
    {
      key: "status",
      icon: FaCheckCircle,
      label: "Status",
      value: statusLabel(version.status),
      valueClass: `cms-page-overview__value cms-page-overview__value--${(version.status || "").toLowerCase()}`,
    },
    {
      key: "version",
      icon: FaHashtag,
      label: "Version",
      value: `v${version.version}`,
    },
    {
      key: "effective",
      icon: FaCalendarAlt,
      label: "Effective Date",
      value: formatDisplayDate(version.effectiveDate),
    },
    {
      key: "updated",
      icon: FaClock,
      label: "Last Updated",
      value: formatUpdatedAt(version.updatedAt),
    },
    {
      key: "by",
      icon: FaUser,
      label: "Updated By",
      value: version.updatedBy || version.createdBy || "Super Admin",
      title: version.updatedBy || version.createdBy || "Super Admin",
    },
  ];

  return (
    <div className="cms-page-overview">
      <h3 className="cms-page-overview__title">Version Overview</h3>
      <ul className="cms-page-overview__list">
        {rows.map(({ key, icon: Icon, label, value, valueClass, title }) => (
          <li key={key} className="cms-page-overview__row">
            <span className="cms-page-overview__icon" aria-hidden>
              <Icon />
            </span>
            <span className="cms-page-overview__copy">
              <span className="cms-page-overview__label">{label}</span>
              <strong className={valueClass || "cms-page-overview__value"} title={title}>
                {value}
              </strong>
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
